export default __webpack_public_path__ + "static/media/services-icon1.0e72699e.png";